import React from 'react'
import {
  RequestAccessWrapper,
  RequestButton,
  RequestAccessTitle,
  RequestAccessInfo,
  SuccessIcon
} from './RequestAccessStyledComponents'
import RequestAccessModal from './RequestAccessModal'
import { FormattedMessage } from 'react-intl'
import { useHistory } from 'react-router-dom'
import StoreError from 'api/StoreError'

interface Props {
  storeId: string,
  error: StoreError,
  setSource: (source: string) => void
}

function RequestAccess({ storeId, error, setSource }: Props) {
  const history = useHistory()
  const [open, setOpen] = React.useState(false)
  const [requestSend, setRequestSend] = React.useState(false)
  return (
    <>
      <RequestAccessWrapper>
        {requestSend ? (
          <React.Fragment>
            <SuccessIcon size='3em' />
            <RequestAccessTitle>
              <FormattedMessage id='general.requestSent' />
            </RequestAccessTitle>
          </React.Fragment>
        ) : (
            <RequestAccessTitle>
              {error.message}
            </RequestAccessTitle>
          )}

        {!requestSend ? (
          <React.Fragment>
            <RequestAccessInfo>
              <FormattedMessage id='general.privateStoreInfo' />
            </RequestAccessInfo>
            <RequestButton
              onClick={() => setOpen(!open)}
            >
              <FormattedMessage id='general.requestAccess' />
            </RequestButton>
          </React.Fragment>
        ) : (
            <React.Fragment>
              <RequestAccessInfo>
                <FormattedMessage id='general.requestSentSuccessfully' />
              </RequestAccessInfo>
              <RequestButton onClick={() => history.push('/')}>
                <FormattedMessage id='general.backToHomepage' />
              </RequestButton>
            </React.Fragment>
          )}
      </RequestAccessWrapper>
      <RequestAccessModal
        {...{
          isOpen: open,
          onRequestSend: () => setRequestSend(!requestSend),
          toggle: () => setOpen(!open),
          storeId: storeId,
          className: 'text-center',
          size: 'xs'
        }}
      />
    </>
  )
}

RequestAccess.displayName = 'RequestAccess'

export default RequestAccess
